// Success Message
const LOGIN_SUCCESS = "we have sent you an email with a link to login";
const MARK_POST_NOT_INTERESTED_SUCCESS = "Thanks for the feedback";
const UNFOLLOWED = "Unfollowed";
const MUTED = "Muted";

// Error messages
const SOMETHING_WENT_WRONG = "Something went wrong! Please try again later.";

const INCORRECT_OTP = "Incorrect OTP. Enter the correct OTP to log in.";

const UNDER_SYSTEM_REVIEW = `It will be reviewed for compliance with institute policies. You'll be notified shortly. Thank you for your patience.`;

const EMAIL_NOT_FOUND = `Account Not Found. Use the email you registered with the school.`;

const messages = {
  SOMETHING_WENT_WRONG,
  LOGIN_SUCCESS,
  INCORRECT_OTP,
  UNDER_SYSTEM_REVIEW,
  MARK_POST_NOT_INTERESTED_SUCCESS,
  UNFOLLOWED,
  MUTED,
  EMAIL_NOT_FOUND,
};

export default messages;
